/**
 * Error Page Routes
 * ============================================================================
 *
 * Purpose:
 * --------
 * Defines error and fallback routes.
 * ============================================================================
 */

import { LAYOUT_TYPES, ROUTE_PATHS } from 'navigation/constants';
import type { RouteConfig, RouteGroup } from 'navigation/types';

// Placeholder error page components
// TODO: Replace with proper error pages from features/errors/ui
const NotFoundPage = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="text-center">
      <h1 className="text-6xl font-bold text-gray-900">404</h1>
      <p className="mt-4 text-xl text-gray-600">Page not found</p>
      <a href="/" className="mt-6 inline-block text-blue-600 hover:underline">
        Go home
      </a>
    </div>
  </div>
);

const UnauthorizedPage = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="text-center">
      <h1 className="text-6xl font-bold text-gray-900">403</h1>
      <p className="mt-4 text-xl text-gray-600">Access denied</p>
      <a href="/" className="mt-6 inline-block text-blue-600 hover:underline">
        Go home
      </a>
    </div>
  </div>
);

const ServerErrorPage = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="text-center">
      <h1 className="text-6xl font-bold text-gray-900">500</h1>
      <p className="mt-4 text-xl text-gray-600">Server error</p>
      <a href="/" className="mt-6 inline-block text-blue-600 hover:underline">
        Go home
      </a>
    </div>
  </div>
);

export const errorPageRoutes: RouteGroup = {
  name: 'errors',
  layout: LAYOUT_TYPES.NONE,
  routes: [
    {
      path: ROUTE_PATHS.NOT_FOUND,
      component: NotFoundPage,
      meta: {
        title: '404 - Page Not Found',
        trackPageView: false,
      },
    },
    {
      path: ROUTE_PATHS.UNAUTHORIZED,
      component: UnauthorizedPage,
      meta: {
        title: '403 - Access Denied',
        trackPageView: false,
      },
    },
    {
      path: ROUTE_PATHS.SERVER_ERROR,
      component: ServerErrorPage,
      meta: {
        title: '500 - Server Error',
        trackPageView: false,
      },
    },
  ],
};

export const notFoundFallbackRoute: RouteConfig = {
  path: '*',
  component: NotFoundPage,
  layout: LAYOUT_TYPES.NONE,
};
